<div class="field-list" [class.nested]="nested">
  <mat-card class="field-card" *ngFor="let field of fields; let i = index">
    <div class="field-header">
      <mat-icon class="type-icon">{{ typeIcon(field.type) }}</mat-icon>
      <div class="field-info">
        <span class="field-title">{{ field.fieldTitle || field.name }}</span>
        <span class="field-meta">
          <code>{{ field.name }}</code> · {{ typeLabel(field.type) }}
          <span *ngIf="field.required" class="required-chip">requerido</span>
        </span>
      </div>
      <span class="spacer"></span>
      <button mat-icon-button matTooltip="Subir" (click)="moveField(i, -1)" [disabled]="i === 0">
        <mat-icon>arrow_upward</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Bajar" (click)="moveField(i, 1)" [disabled]="i === fields.length - 1">
        <mat-icon>arrow_downward</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Editar campo" (click)="editField(i)">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button color="warn" matTooltip="Eliminar campo" (click)="deleteField(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <!-- Opciones resumidas -->
    <div class="options-summary" *ngIf="field.options?.length">
      <span class="option-chip" *ngFor="let option of field.options">
        <img *ngIf="option.imageUrl" [src]="option.imageUrl" alt="" />
        {{ option.option }}
      </span>
    </div>

    <!-- Dependencias -->
    <div class="dependencies" *ngIf="canHaveDependencies(field)">
      <div class="dependency-group" *ngFor="let dep of dependencyEntries(field)">
        <div class="dependency-header">
          <mat-icon>subdirectory_arrow_right</mat-icon>
          <span>Si responde <strong>"{{ dep.answer }}"</strong></span>
          <span class="spacer"></span>
          <button mat-icon-button color="warn" matTooltip="Eliminar grupo"
                  (click)="removeDependencyGroup(field, dep.answer)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
        <app-field-list
          [fields]="dep.fields"
          [nested]="true"
          (fieldsChange)="onNestedChange()">
        </app-field-list>
      </div>

      <button mat-button color="primary" class="add-dependency"
              *ngIf="availableAnswers(field).length"
              [matMenuTriggerFor]="answersMenu">
        <mat-icon>add_link</mat-icon>
        Agregar campos según respuesta
      </button>
      <mat-menu #answersMenu="matMenu">
        <button mat-menu-item *ngFor="let answer of availableAnswers(field)"
                (click)="addDependencyGroup(field, answer)">
          {{ answer }}
        </button>
      </mat-menu>
    </div>
  </mat-card>

  <button mat-stroked-button color="primary" class="add-field-button" (click)="addField()">
    <mat-icon>add</mat-icon>
    Agregar campo
  </button>
</div>
